import { render, staticRenderFns } from "./imprimirDetails.vue?vue&type=template&id=3e7d148a&scoped=true&"
import script from "./imprimirDetails.vue?vue&type=script&lang=js&"
export * from "./imprimirDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7d148a",
  null
  
)

export default component.exports